import { createUseStyles, useTheme } from 'react-jss';
import { Theme } from '@app/theme';
import { Link } from '@app/core';
import { useTranslation } from 'react-i18next';
import { Feature } from '@app/api';
import { useFeatureRequiredCallback } from '../Features';

const useStyles = createUseStyles((theme: Theme) => ({
  collapsed: {
    ...theme.fonts.label,
    color: theme.colors.blueAccessible,
  },
  expended: {
    ...theme.fonts.label,
    color: theme.colors.redAccessible,
  },
}));

interface Props {
  value: boolean;
  onClick: () => void;
}

export const AddQuotaButton = ({ value, onClick }: Props) => {
  const theme: Theme = useTheme();
  const classes = useStyles({ theme });
  const { t } = useTranslation();

  const unlockFeature = useFeatureRequiredCallback(Feature.QUOTA, onClick);

  return (
    <Link
      className={value ? classes.expended : classes.collapsed}
      onClick={unlockFeature}
      type="button"
    >
      {value
        ? t('editSession.targeting.quotas.removeQuotas')
        : t('editSession.targeting.quotas.setQuotas')}
    </Link>
  );
};
